export * from "../../base/store/getters";

export function get_options(state) {
	return state.options;
}
